;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.neighborhoodDropdown = (function () {
    const initialize = function () {
      $('.neighborhood-dropdown-form').submit(function (e) {
        e.preventDefault()
        window.location.href = $('#location').val()
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.neighborhoodDropdown.initialize()
  })
}(jQuery, window))
